import React from 'react';
export function Footer() {
  return <footer className="bg-brand-navy px-4 py-10 text-center" data-id="element-84" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-content" data-id="element-85" data-mp="3gfiuujlrgden">
        <p className="font-display text-sm font-bold tracking-wide text-white/90" data-id="element-86" data-mp="3ghc3g4fxp7pa">EDUCAZIONE FISICA PRONTA™</p>
        <div className="mx-auto my-6 h-px max-w-sm bg-white/10" data-id="element-87" data-mp="32m1aiwl92wnk" />
        <nav aria-label="Note legali" className="flex items-center justify-center gap-3 text-xs text-white/70" data-id="element-88" data-mp="36pzblcu4yhj9">
          <a href="#termini" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-89" data-mp="3uftlpmn2lrzt">
            Termini
          </a>
          <span aria-hidden="true" data-id="element-90" data-mp="3lec768pb9yd8">·</span>
          <a href="#privacy" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-91" data-mp="3ldkcr17ga6oj">
            Privacy
          </a>
          <span aria-hidden="true" data-id="element-92" data-mp="3qfjhofiu9bnl">·</span>
          <a href="#contatti" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-93" data-mp="29yxehh44xsnx">
            Contatti
          </a>
        </nav>
        <p className="mt-6 text-[10px] text-white/45" data-id="element-94" data-mp="2ezl0tphf5lbt">© 2026 EDUCAZIONE FISICA PRONTA™. Tutti i diritti riservati.</p>
      </div>
    </footer>;
}